// Shared helpers for Lone Wolf forms, used by the Documents → Forms tab (TransactionDocuments)
// and the TDS/SPQ prospect stages on the Timeline (LoneWolfStageFormCard).

// Legal-name fallbacks for when Lone Wolf returns no acronym (mirrors mobile DocsTab.tsx).
const TDS_SPQ_NAME_PATTERNS = {
  TDS: [/^\s*TDS\s*-/i, /^\s*(real\s+estate\s+)?transfer\s+disclosure\s+statement\s+-/i],
  SPQ: [/^\s*SPQ\s*-/i, /^\s*seller\s+property\s+questionnaire\s+-/i],
};

/**
 * True when a Lone Wolf form is the given TDS/SPQ form. Prefers Lone Wolf's exact acronym, so
 * look-alikes (TDS-1, MHTDS, CSPQ, ...) don't match; falls back to the legal name only when no
 * acronym came back. Accepts a raw Lone Wolf form ({acronym, name}) or a Forms-tab row
 * ({_acronym, name/title}).
 */
export const isLoneWolfFormOfType = (form, type) => {
  const acronym = (form?._acronym ?? form?.acronym ?? '').trim().toUpperCase();
  if (acronym) return acronym === type;
  const name = form?.name || form?.formName || form?.title || '';
  return (TDS_SPQ_NAME_PATTERNS[type] || []).some((re) => re.test(name));
};

/**
 * TDS/SPQ detection for a Lone Wolf form row. The backend re-validates from the PDF text and
 * rejects any non-TDS/SPQ form.
 */
export const isTdsSpqLoneWolfForm = (form) =>
  isLoneWolfFormOfType(form, 'TDS') || isLoneWolfFormOfType(form, 'SPQ');

/** Status label + badge colors for a Lone Wolf form, from its signing (null → no signing yet). */
export const getLoneWolfSigningStatus = (signing) => {
  if (!signing) return { label: 'Draft', style: { background: '#fff4e6', color: '#b06a00' } };
  const statusId = signing.statusId;
  if (signing.finalized === true || statusId === 3) {
    return { label: 'Signed', style: { background: '#e8f5e9', color: '#2e7d32' } };
  }
  if (statusId === 2) return { label: 'In Progress', style: { background: '#ede7f6', color: '#5B47D6' } };
  if (statusId === 0) return { label: 'Draft', style: { background: '#fff4e6', color: '#b06a00' } };
  return { label: 'Sent', style: { background: '#ede7f6', color: '#5B47D6' } };
};
